//MUI Components
import { Box, Button, List, ListItem, Typography, Grid2 } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import DownloadIcon from "@mui/icons-material/Download";

//My Components
import { Header } from "../header";
import { Footer } from "../footer";
import OptionsTab from "../optionsBar";
import CustomTable from "../table";
import PersonalizedCarousel from "../carousel";
import ThreeViewer from "../viewer";

// Assets
import mailsito from "../../assets/images/MAIL.png";
import wpp from "../../assets/images/WHATSAPP.png";

import { useTranslation } from "react-i18next";

function Producto({
  fotos,
  datosTabla1,
  datosTabla2,
  nombreProducto,
  fotoProducto,
  descripcionProducto,
  caracteristicas,
  vendedor,
  pathPdf,
  tieneTabla2 = true,
  renderPath = null,
  cameraDistance,
  xPi,
  yPi
}) {

  const { t } = useTranslation();
  const columns1 = [t("caracteristica"), t("unidad"), t("valor")];
  const columns2 = [t("dimensiones"), t("unidad"), t("valor")];

  return (
    <>
      <div style={{ position: "relative", minHeight: "100vh", overflowX: "hidden", background: "#FFF" }}>
        <Header color="#F0F0F0" />

        <Box
          sx={{
            marginTop: { xs: "7rem", md: "9rem" },
            marginLeft: { xs: "1rem", md: "6rem", xl: "18rem" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "center", md: "flex-start" },
            gap: "2rem",
            textAlign: { xs: "center", md: "left" },
          }}
        >
          {/* Columna de texto */}
          <Box sx={{ width: { xs: "100%", md: "40%" } }}>
            <Typography sx={{ color: "#1B2466", fontFamily: "Montserrat", fontSize: { xs: "32px", md: "50px" }, fontWeight: 800, lineHeight: { xs: "38px", md: "50px" } }}>
              {nombreProducto}
            </Typography>

            <Typography sx={{ color: "#1B2466", fontFamily: "Montserrat", fontSize: { xs: "16px", md: "21.3px" }, fontWeight: 700, lineHeight: { xs: "22px", md: "29.3px" }, letterSpacing: "-0.133px", mt: 2, mb: 2 }}>
              {descripcionProducto}
            </Typography>

            <List disablePadding>
              {Array.isArray(caracteristicas) &&
                caracteristicas.map((item, index) => (
                  <ListItem key={index} sx={{ color: "#1B2466", fontFamily: "Montserrat", fontSize: { xs: "14px", md: "18px" }, fontWeight: 400, lineHeight: { xs: "20px", md: "20px" }, py: 0.5, justifyContent: { xs: "flex-start", md: "flex-start" }, alignItems: "flex-start" }}>
                    <FiberManualRecordIcon sx={{ fontSize: 8, mr: 1.5, mt: "6px" }} />
                    {item}
                  </ListItem>
                ))}
            </List>

            <Box sx={{ marginTop: "1.5rem", marginBottom: "2rem", display: "flex", justifyContent: { xs: "center", md: "flex-start" } }}>
              <a href={pathPdf} download style={{ textDecoration: "none" }}>
                <Button sx={{ width: { xs: "9rem", md: "11rem" }, height: "3.5rem", flexShrink: 0, borderRadius: "15px", background: "#D9D9D9", display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  <DownloadIcon sx={{ color: "#1B2466", fontSize: "24px" }} />
                  <Typography sx={{ color: "#1B2466", fontFamily: "Montserrat", fontSize: { xs: "17px", md: "15px" }, fontWeight: 700, lineHeight: { xs: "20px", md: "19px" }, letterSpacing: "-0.133px", textTransform: "none" }}>
                    {t("descargar")}
                  </Typography>
                </Button>
              </a>
            </Box>
          </Box>

          {/* Viewer 3D o imagen */}
          {renderPath ? (
            <ThreeViewer src={renderPath} distance={cameraDistance} xPi={xPi} yPi={yPi} />
          ) : (
            <Box component="img" src={fotoProducto} alt={nombreProducto} sx={{ width: { xs: "80%", md: "80%" }, maxWidth: "600px", maxHeight: "500px", height: "auto", objectFit: "contain", marginLeft: { xs: 0, md: "5rem" }, marginTop: { xs: "2rem", md: "0rem" } }} />
          )}
        </Box>

        {/* Tabs y tablas */}
        <Box>
          <OptionsTab labels={[t("tabla"), t("fotos"), t("contacto")]}>
            <Grid2 container alignItems="start" justifyContent={"space-around"}>
              <Grid2 item="true" style={{ marginRight: "1.8rem" }}>
                <CustomTable columns={columns1} data={datosTabla1} />
              </Grid2>
              {tieneTabla2 && (
                <Grid2 item sx={{ marginRight: "1.8rem" }}>
                  <CustomTable columns={columns2} data={datosTabla2} />
                </Grid2>
              )}
            </Grid2>

            <Grid2 container alignItems="center">
              <Grid2 item="true" style={{ width: "100%", marginRight: "1.8rem" }}>
                <PersonalizedCarousel pics={fotos} />
              </Grid2>
            </Grid2>

            <Grid2 container spacing={3} width="100%" marginTop={{xs: "1rem", md:"4.5rem"}} justifyContent="space-around">
              <Grid2 item xs={12} md={3} display="flex" alignItems="center">
                <Typography sx={{ color: "#1B2466", fontFamily: "Montserrat", fontSize: { xs: "15px", md: "20px" }, fontWeight: 800 }}>
                  {t("por_consultas_contactar")}
                </Typography>
              </Grid2>

              <Grid2 item xs={12} md={5} display="flex" alignItems="flex-start">
                <Box marginT>
                  <Typography sx={{ color: "#1B2466", fontFamily: "Montserrat", fontSize: { xs: "13px", md: "18px" }, fontWeight: 800, marginBottom: "0.5rem" }}>
                    {vendedor.nombre}
                  </Typography>

                  <Box display="flex" alignItems="center" marginBottom="0.5rem">
                    <img src={wpp} alt="wpp" style={{ width: "24px", height: "24px", marginRight: "0.5rem" }} />
                    <Typography sx={{ color: "#1B2466", fontFamily: "Montserrat", fontSize: { xs: "14px", md: "18px" }, fontWeight: 400 }}>
                      {vendedor.telefono}
                    </Typography>
                  </Box>

                  <Box display="flex" alignItems="center">
                    <img src={mailsito} alt="mail" style={{ width: "24px", height: "24px", marginRight: "0.5rem" }} />
                    <Typography sx={{ color: "#1B2466", fontFamily: "Montserrat", fontSize: { xs: "14px", md: "18px" }, fontWeight: 400 }}>
                      {vendedor.mail}
                    </Typography>
                  </Box>
                </Box>
              </Grid2>

              <Grid2 item xs={12} md={3} display="flex" flexDirection="column" alignItems="center" textAlign="center">
                <img src={vendedor.qr} alt="QR" style={{ width: "120px", height: "120px", marginBottom: "0.5rem" }} />
                <Typography sx={{ color: "#1B2466", fontFamily: "Montserrat", fontSize: { xs: "14px", md: "18px" }, fontWeight: 400 }}>
                  {t("qr_scan")}
                </Typography>
              </Grid2>
            </Grid2>
          </OptionsTab>
        </Box>
      </div>

      <Box sx={{ marginTop: "3rem" }}>
        <Footer />
      </Box>
    </>
  );
}

export default Producto;
